import React from 'react';
import { COMPANY_INFO } from '../utils/constants';
import './LegalPages.css';

const TermsOfService: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Terms of Service - Pickup Rental Truck Dubai",
    "description": "Terms of Service for Pickup Rental Truck Dubai. Read our terms and conditions for using our truck rental services.",
    "url": `${COMPANY_INFO.website}/terms-of-service`,
    "isPartOf": {
      "@type": "WebSite",
      "name": COMPANY_INFO.name,
      "url": COMPANY_INFO.website
    }
  };

  return (
    <div className="legal-page">
        <div className="container">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using the services of {COMPANY_INFO.name}, you accept and agree 
              to be bound by the terms and provision of this agreement. If you do not agree to 
              abide by the above, please do not use this service.
            </p>
          </section>

          <section>
            <h2>2. Service Description</h2>
            <p>
              {COMPANY_INFO.name} provides pickup truck rental services in Dubai, UAE, including:
            </p>
            <ul>
              <li>1-10 ton pickup truck rentals</li>
              <li>Home and office shifting services</li>
              <li>Delivery and transportation services</li>
              <li>Professional driver services</li>
              <li>Tail lift equipped vehicles</li>
            </ul>
          </section>

          <section>
            <h2>3. Booking and Reservations</h2>
            <h3>3.1 Booking Process</h3>
            <ul>
              <li>All bookings must be made through our official channels</li>
              <li>Advance booking is recommended to ensure availability</li>
              <li>Bookings are subject to vehicle availability</li>
              <li>We reserve the right to refuse service at our discretion</li>
            </ul>

            <h3>3.2 Cancellation Policy</h3>
            <ul>
              <li>Cancellations made 24 hours in advance: No charge</li>
              <li>Cancellations made less than 24 hours: 50% of service fee</li>
              <li>No-show or same-day cancellation: Full service fee</li>
              <li>Weather-related cancellations: No charge</li>
            </ul>
          </section>

          <section>
            <h2>4. Payment Terms</h2>
            <h3>4.1 Payment Methods</h3>
            <ul>
              <li>Cash payments accepted</li>
              <li>Bank transfer</li>
              <li>Credit/debit cards (subject to availability)</li>
            </ul>

            <h3>4.2 Pricing</h3>
            <ul>
              <li>All prices are quoted in UAE Dirhams (AED)</li>
              <li>Prices are subject to change without notice</li>
              <li>Additional charges may apply for extra services</li>
              <li>Fuel costs are included in the service fee</li>
            </ul>
          </section>

          <section>
            <h2>5. Customer Responsibilities</h2>
            <h3>5.1 Accurate Information</h3>
            <ul>
              <li>Provide accurate contact and address information</li>
              <li>Specify correct pickup and delivery locations</li>
              <li>Inform us of any special requirements or restrictions</li>
            </ul>

            <h3>5.2 Prohibited Items</h3>
            <ul>
              <li>Hazardous materials and dangerous goods</li>
              <li>Illegal items or contraband</li>
              <li>Perishable items without proper packaging</li>
              <li>Items exceeding vehicle capacity</li>
            </ul>
          </section>

          <section>
            <h2>6. Service Limitations</h2>
            <ul>
              <li>Services are subject to weather conditions</li>
              <li>Access restrictions may apply to certain areas</li>
              <li>Vehicle capacity limits must be respected</li>
              <li>Service availability may vary by location</li>
            </ul>
          </section>

          <section>
            <h2>7. Liability and Insurance</h2>
            <h3>7.1 Our Liability</h3>
            <ul>
              <li>We maintain comprehensive vehicle insurance</li>
              <li>Our liability is limited to the service fee paid</li>
              <li>We are not liable for delays due to traffic or weather</li>
              <li>Customer's personal items are transported at their own risk</li>
            </ul>

            <h3>7.2 Customer Liability</h3>
            <ul>
              <li>Customers are responsible for securing their belongings</li>
              <li>Damage to vehicle due to customer negligence is chargeable</li>
              <li>Customers must comply with UAE traffic laws</li>
            </ul>
          </section>

          <section>
            <h2>8. Driver Services</h2>
            <ul>
              <li>All drivers are licensed and experienced</li>
              <li>Drivers follow UAE traffic regulations</li>
              <li>Driver working hours comply with labor laws</li>
              <li>Additional driver charges may apply for extended hours</li>
            </ul>
          </section>

          <section>
            <h2>9. Privacy and Data Protection</h2>
            <p>
              We collect and process personal information in accordance with our Privacy Policy. 
              By using our services, you consent to the collection and use of your information 
              as described in our Privacy Policy.
            </p>
          </section>

          <section>
            <h2>10. Intellectual Property</h2>
            <p>
              All content on our website, including text, graphics, logos, and images, is the 
              property of {COMPANY_INFO.name} and is protected by copyright laws.
            </p>
          </section>

          <section>
            <h2>11. Dispute Resolution</h2>
            <p>
              Any disputes arising from the use of our services will be resolved through 
              negotiation. If resolution cannot be reached, disputes will be subject to the 
              jurisdiction of Dubai courts, UAE.
            </p>
          </section>

          <section>
            <h2>12. Force Majeure</h2>
            <p>
              We shall not be liable for any failure or delay in performance due to circumstances 
              beyond our reasonable control, including but not limited to natural disasters, 
              government actions, or other force majeure events.
            </p>
          </section>

          <section>
            <h2>13. Modifications to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Changes will be effective 
              immediately upon posting on our website. Continued use of our services constitutes 
              acceptance of the modified terms.
            </p>
          </section>

          <section>
            <h2>14. Contact Information</h2>
            <p>
              For questions regarding these Terms of Service, please contact us:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> mkashiff6@gmail.com</p>
              <p><strong>Phone:</strong> 0543507981</p>
              <p><strong>Address:</strong> Al Quoz 4 Industrial Area, Dubai, UAE</p>
            </div>
          </section>
        </div>
      </div>
  );
};

export default TermsOfService;
